(function () {
  angular
    .module('MktzapApp.Controllers')
    .requires
    .push();
  angular.module('MktzapApp.Controllers')
    .controller('MetabaseController', MetabaseController)
  MetabaseController.$inject = ['$rootScope', '$scope', '$stateParams', 'DashboardService', 'NotificationService'];
  function MetabaseController ($rootScope, $scope, $stateParams, DashboardService, NotificationService) {
    var vmDashMetabase = this;
    $rootScope.fullscreen = true;

    DashboardService
      .getMetabaseUrl({
        dash: $stateParams.dash
      })
      .$promise
      .then(function (data) {
        vmDashMetabase.url = data.url;
      })
      .catch(function (error) {
        NotificationService.errorHandler(error, $scope.labels.errorOperation);
      });
  }
})();
